export const renderUserUuid = (uuid: string) => <span css={{ fontFamily: "monospace" }}>{uuid.slice(0, 8)}…</span>;
export const formatUserUuid = (uuid: string) => `${uuid.slice(0, 8)}…`;
